<template>
  <div class="vx-row">
    <div class="w-full lg:w-full border border-solid d-theme-border-grey-light rounded">
      <div class="vx-card" style="padding:5px;">
      <div class="vx-card__collapsible-content text-center" style="padding:5px; height:100%; margin:5px;">
        <div class="vx-row justify-center mb-base">
          <h4> 강의 시간표 </h4>
        </div>
        <div class="vx-row mb-base" style="margin-left:20px; margin-right:10px;">
          <div class="btn-group">
            <vs-button type="border" @click="selectFlag = true">전체</vs-button>
            <vs-button type="border" @click="selectFlag = false">요일별</vs-button>
          </div>
            <vs-button @click="activePrompt2=true" icon-pack="feather" icon="icon-settings" type="flat" style="margin-top:5px; margin-left:3px; margin-bottom:5px;" color="dark"/>
            <vs-button icon-pack="feather" icon="icon-upload" type="flat" style="margin-top:5px; margin-left:5px; margin-right:3px; margin-bottom:5px;" color="dark"/>
        </div>
        <div v-if="selectFlag" class="vx-row justify-center">
          <div class="vx-col" style="margin-top:10px; margin-left:-15px; margin-right:-15px;">
            <vx-card noShadow noRadius style="width:50px; background-color:#ccc; height:50px;">
              <!-- <h5 style="margin-top:-5px; font-size:12px;" >시간</h5> -->
              <vs-button disabled icon-pack="feather" icon="icon-clock" type="flat" color="dark" style="margin-top:-15px; margin-left:-16px; align:center;"/>
            </vx-card>
            <vx-card noShadow cardBorder noRadius v-for="(time, index) in timeList" :key="index" style="border-color: #cae7e7; width:50px; height:100px; font-size:10px;">
              <p style="margin-left:-15px;">{{time}} </p></vx-card>
          </div>
          <div v-for="(week, weekIndex) in weekList" :key="weekIndex" style="width:8%; margin:10px;">
            <div class="vx-col" style="margin-left:-3px; margin-right:-15px;">
              <vx-card noShadow noRadius style="background-color:#cae7e7; height:50px;">
                <h5 style="margin-top:-5px; margin-left:-12px;" >{{week}}</h5>
              </vx-card>
              <div v-for="(val, index) in timeListSize" :key="index" >
                <vx-card v-if="timeTableVal[index][weekIndex] == 0" noShadow cardBorder noRadius @click="addSchedule(weekIndex, val)" style="height:100px;"/>
                <vx-card v-if="timeTableVal[index][weekIndex] != 0" noShadow cardBorder noRadius @click="editSchedule(timeTableVal[index][weekIndex]-1, weekIndex, val)"
                :style="{'background-color': schedules[timeTableVal[index][weekIndex]-1].color,'height':'100px'}">
                  <div style="margin-left:-18px;">{{schedules[timeTableVal[index][weekIndex]-1].class_name}}</div>
                </vx-card>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!selectFlag" class="vx-col justify-center lg:w-full" style="padding:10px;">
          <div class="vx-row">
          <div class="vx-col" style="width:20%; margin-top:15px; margin-left:-1px; margin-right:-15px;">
            <vx-card noShadow cardBorder noRadius style="background-color:#ccc; height:50px; margin-bottom:9px; margin-top:-8px;">
              <!-- <h5 style="margin-top:-5px; font-size:12px;" >시간</h5> -->
              <vs-button disabled icon-pack="feather" icon="icon-clock" type="flat" color="dark" style="margin-top:-15px; margin-left:-25px; align:center;"/>
            </vx-card>
            <vx-card noShadow cardBorder noRadius v-for="(time, weekIndex) in timeList" :key="weekIndex" style="height:100px; font-size:12px;">
              <p style="margin-left:-22px;"> {{time}}</p>
            </vx-card>
          </div>
          <!-- <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl" style="width:80%; margin-left:10px;">
           <swiper-slide v-for="item in weekList" :key="item">
            <vx-card style="background-color:#cae7e7; width:90%; height:50px; margin:10px;">
              <h5 style="margin-top:-5px;">{{item}}</h5>
            </vx-card>
            <vx-card v-for="time in timeList" :key="time" @click="activePrompt = true" style="width:90%; height:100px; margin-left:10px; margin-top:3px;">{{ val == null ? 'null' : val }}</vx-card>
          </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper> -->
          <vs-tabs style="width:80%; margin-left:10px; margin-top:15px;">
            <vs-tab v-for="(item, weekIndex) in weekList" :key="weekIndex" :label="item">
              <div class="tab-text">
                <!-- <vx-card noShadow cardBorder noRadius v-for="(time, index) in timeListSize" :key="index" @click="activePrompt = true" style="width:90%; height:100px; margin-left:2px; margin-top:3px;">{{ val == null ? 'null' : val }}</vx-card> -->
                <div v-for="(val, index) in timeListSize" :key="index" >
                  <vx-card v-if="timeTableVal[index][weekIndex] == 0" noShadow cardBorder noRadius @click="addSchedule(weekIndex, val)" style="width:90%; height:100px; margin-left:2px;"/>
                  <vx-card v-if="timeTableVal[index][weekIndex] != 0" noShadow cardBorder noRadius @click="editSchedule(timeTableVal[index][weekIndex]-1, weekIndex, val)"
                  :style="{'background-color': schedules[timeTableVal[index][weekIndex]-1].color, 'width':'90%', 'margin-left':'2px', 'height':'100px'}">
                    <div>{{schedules[timeTableVal[index][weekIndex]-1].class_name}}</div>
                  </vx-card>
                </div>
              </div>
            </vs-tab>
          </vs-tabs>
        </div>
      </div>
     </div>
    </div>
  </div>
  <vs-prompt
     title="강의 입력"
     accept-text="완료"
     cancel-text="취소"
     @cancel="clearFields"
     @accept="acceptAddSchedule"
     @close="clearFields"
     :active.sync="activePrompt">
     <div class="con-exemple-prompt" style="margin-bottom:-15px;">
       <!-- <span style="margin-bottom:10px;">시간 설정</span> -->
       <h6 style="margin-bottom:5px;"> 시작시간 &nbsp; <span>{{newData.start_data}} </span></h6>
       <div class="vx-row mt-3 w-full">
         <h6 style="margin-left:14px; margin-bottom:5px;"> 종료시간</h6>
         <!-- <v-select class="lg:w-2/6 md:w-2/4 sm:w-2/3" style="margin-left:5px; margin-right:15px;"  placeholder="시작시간"  v-model="startTimeSelected" :options="timeList" :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
         <v-select class="lg:w-full w-full" style="margin-left:12px; margin-right:15px; margin-bottom:5px;"  placeholder="종료시간"  v-model="newData.end_data" :options="endTimeList" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        <!-- <flat-pickr :config="configdateTimePicker" v-model="timeTableInfo.start_data" placeholder="시작시간" style="margin-left:15px; margin-top:5px; margin-right:15px;" />
        <vs-button class="vx-row justify-end" icon-pack="feather" icon="icon-check" type="flat" style="margin-top:5px;"/><br>
        <flat-pickr :config="configdateTimePicker" v-model="timeTableInfo.end_data" placeholder="종료시간" style="margin-left:15px; margin-top:5px; margin-right:15px; margin-bottom:15px;" />
        <vs-button class="vx-row justify-end" icon-pack="feather" icon="icon-check" type="flat" style="margin-top:5px;"/> -->
       </div>
       <span>과목 입력</span>
       <vs-input placeholder="과목명" vs-placeholder="과목명" v-model="newData.class_name" class=" w-full" style="margin-bottom:10px;"/>
       <span>강의실</span>
       <vs-input placeholder="강의실" vs-placeholder="강의실" v-model="newData.room" class=" w-full" style="margin-bottom:10px;"/>
       <span>교수</span>
       <vs-input placeholder="교수" vs-placeholder="교수님" v-model="newData.professor" class=" w-full" style="margin-bottom:10px;"/>
       <span> 표시 색상</span>
       <div class="vx-row mt-3 w-full clearfix" style="margin-left:3px;">
         <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#2a8eba" @click="newData.color='#2a8eba'"/>
         <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#f8ef76" @click="newData.color='#f8ef76'"/>
         <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#ffdcff" @click="newData.color = '#ffdcff'"/>
         <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#7fadca" @click="newData.color = '#7fadca'"/>
         <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#fa8072" @click="newData.color = '#fa8072'"/>
         <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#a4cf1f" @click="newData.color = '#a4cf1f'"/>
         <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#ec4c20" @click="newData.color = '#ec4c20'"/>
         <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#2fe5a8" @click="newData.color = '#2fe5a8'"/>
        </div>
          <br>
       </div>
     </vs-prompt>
     <vs-prompt
        title="강의 수정"
        accept-text="수정"
        cancel-text="삭제"
        @cancel="deleteSchedule"
        @accept="acceptEditSchedule"
        @close="clearFields"
        :active.sync="activePrompt3">
        <div class="con-exemple-prompt" style="margin-bottom:-20px;">
          <!-- <span>시간 설정</span> -->
          <div class="vx-row mt-3 w-full">
            <v-select class="lg:w-2/6 md:w-2/4 sm:w-2/3" style="margin-left:10px; margin-right:8px; margin-bottom:5px;"  placeholder="시작시간"  v-model="startTimeSelected" :options="startTimeList" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            <v-select class="lg:w-2/6 md:w-2/4 sm:w-2/3" style="margin-left:5px; margin-right:8px; margin-bottom:5px;"  placeholder="종료시간"  v-model="newData.end_data" :options="endTimeList" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
           <!-- <flat-pickr :config="configdateTimePicker" v-model="timeTableInfo.start_data" placeholder="시작시간" style="margin-left:15px; margin-top:5px; margin-right:15px;" />
           <vs-button class="vx-row justify-end" icon-pack="feather" icon="icon-check" type="flat" style="margin-top:5px;"/><br>
           <flat-pickr :config="configdateTimePicker" v-model="timeTableInfo.end_data" placeholder="종료시간" style="margin-left:15px; margin-top:5px; margin-right:15px; margin-bottom:15px;" />
           <vs-button class="vx-row justify-end" icon-pack="feather" icon="icon-check" type="flat" style="margin-top:5px;"/> -->
          </div>
          <span>과목 입력</span>
          <vs-input placeholder="과목명" vs-placeholder="과목명" v-model="newData.class_name" class="w-full" style="margin-bottom:10px;"/>
          <span>강의실</span>
          <vs-input placeholder="강의실" vs-placeholder="강의실" v-model="newData.room" class="w-full" style="margin-bottom:10px;"/>
          <span>교수</span>
          <vs-input placeholder="교수" vs-placeholder="교수님" v-model="newData.professor" class="w-full" style="margin-bottom:10px;"/>
          <span> 표시 색상</span>
          <div class="vx-row mt-3 w-full clearfix" style="margin:10px;">
            <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#2a8eba" @click="newData.color = '#2a8eba'"/>
            <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#f8ef76" @click="newData.color = '#f8ef76'"/>
            <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#ffdcff" @click="newData.color = '#ffdcff'"/>
            <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#7fadca" @click="newData.color = '#7fadca'"/>
            <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#fa8072" @click="newData.color = '#fa8072'"/>
            <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#a4cf1f" @click="newData.color = '#a4cf1f'"/>
            <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#ec4c20" @click="newData.color = '#ec4c20'"/>
            <button class="h-8 w-8 cursor-pointer rounded m-2 float-left" style="background-color:#2fe5a8" @click="newData.color = '#2fe5a8'"/>
           </div>
             <br>
          </div>
        </vs-prompt>
     <vs-prompt
        title="시간표 설정"
        accept-text="완료"
        cancel-text="취소"
        @cancel="clearFields"
        @accept="acceptAlert"
        @close="clearFields"
        :active.sync="activePrompt2">
        <div class="con-exemple-prompt">
          <span> 시간 단위 </span>
            <ul class="vx-row mt-3" style="margin-bottom:10px;">
              <li>
                <vs-radio v-model="timeTableInfo.minutes" vs-value="30" style="margin-left:12px;">30분 간격</vs-radio>
              </li>
              <li>
                <vs-radio v-model="timeTableInfo.minutes" vs-value="60" style="margin-left:15px;">1시간 간격</vs-radio>
              </li>
            </ul>
          <span>시간 설정</span>
            <div class="vx-row mt-3 w-full">
             <flat-pickr :config="configdateTimePicker" v-model="timeTableInfo.start_data" placeholder="시작시간" style="margin-left:12px; margin-top:5px; margin-right:15px;" />
             <vs-button class="vx-row justify-end" icon-pack="feather" icon="icon-check" type="flat"/>
             <flat-pickr :config="configdateTimePicker" v-model="timeTableInfo.end_data" placeholder="종료시간" style="margin-left:12px; margin-top:5px; margin-right:15px; margin-bottom:15px;" />
             <vs-button class="vx-row justify-end" icon-pack="feather" icon="icon-check" type="flat"/>
            </div>
           <br>
        </div>
        </vs-prompt>
   </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import vSelect from 'vue-select'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import Timeselector from 'vue-timeselector';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import moduleTimeTable from '@/store/timeTable/moduleTimeTable.js'

export default{
  data() {
    return {
      timeTableInfo:{
        id:0,
        minutes: 30,
        start_data: null,
        end_data: null,
      },
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true
      },
      newData:{
        table_id:0,
        color:'#ffffff',
        room:'',
        class_name:'',
        professor:'',
        start_data:'',
        end_data:'',
        week:0,
        workspace_id:0
      },
      oldData:{},
      timeListSize: 0,
      weekList : ['월', '화', '수', '목', '금'],
      selectFlag :true,
      activePrompt:false,
      activePrompt2:false,
      activePrompt3:false,
      startTimeSelected:'',
      endTimeSelected:'',
      timeList : [],
      editTimeList:[],
      startTimeList:[],
      endTimeList:[],
      timeTableVal:[],
      selectStartIndex:0,
      eventFlag:false,
      selectEventFlag:false,
      val:'',
      val2:'',
      val3:'',
      swiperOption: {
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  watch: {
    startTimeSelected(){
      this.resetEndTimeList()
      this.newData.start_data = this.startTimeSelected
    },
    selectEventFlag(){
      this.setEndTimeList()
    },
    eventFlag(){
      this.weekList = ['월', '화', '수', '목', '금']
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    schedules() {
      return this.$store.state.timeTable.schedules
    },
  },
  beforeDestroy() {
    this.$store.unregisterModule('timeTable')
  },
  created(){
    this.$store.registerModule('timeTable', moduleTimeTable)
    this.$store.dispatch("timeTable/getTimeTableSetting", this.activeUserInfo.uid).then((resolve)=>{
      this.timeTableInfo = resolve.data.data
      this.setTimeTable()
      this.newData.table_id = this.timeTableInfo.id // table id 셋팅.
      this.$store.dispatch("timeTable/getTimeTable", this.newData.table_id).then(()=>{
        this.setScheduleVector()
      })
    })
  },
  methods:{
    setEndTimeList(){
      this.endTimeList = []
      for(var index = this.selectStartIndex+1; index < this.timeList.length; index++){
        if(this.timeList[index] > this.newData.start_data && this.timeTableVal[index][this.newData.week] == 0){
          this.endTimeList.push(this.timeList[index])
        }else {
          this.endTimeList.push(this.timeList[index])
          break
        }
      }
      if(this.newData.end_data <= this.newData.start_data){
        this.newData.end_data = ''
      }
    },
    resetEndTimeList(){
      this.endTimeList = []
      var index = this.editTimeList.findIndex(val => {return val == this.startTimeSelected})
      for(index= index+1; index < this.editTimeList.length; index++){
        this.endTimeList.push(this.editTimeList[index])
      }
      if(this.newData.end_data <= this.startTimeSelected){
        this.newData.end_data = ''
      }
    },
    deleteSchedule(){
      this.$store.dispatch("timeTable/deleteTimeTable", this.newData.id).then(()=>{
        // this.setScheduleVector()
        var start = this.timeList.findIndex(val => {return val == this.newData.start_data})
        var end = this.timeList.findIndex(val => {return val == this.newData.end_data})
        for(start; start < end; start++){
          this.timeTableVal[start][this.newData.week] = 0
        }
        this.eventFlag = !this.eventFlag
        this.$store.commit('timeTable/DELETE_SCHEDULE', this.newData.id)

        // this.eventFlag = !this.eventFlag
      })
    },
    setScheduleVector(){
      for (var index in this.schedules){
        var start = this.timeList.findIndex(val => {return val == this.schedules[index].start_data})
        var end = this.timeList.findIndex(val => {return val == this.schedules[index].end_data})
        for(start;start < end; start++){
          this.timeTableVal[start][this.schedules[index].week] = Number(index)+1
        }
      }
      this.eventFlag = !this.eventFlag
    },
    acceptEditSchedule(){
      if(this.newData.start_data == '' || this.newData.end_data == '' ){
        this.$vs.notify({
          color:'danger',
          title:'에러',
          text:'시작 시간과 종료 시간을 설정해주세요'
        })
        this.activePrompt3 = true
      }
      if(this.newData.class_name == ''){
        this.$vs.notify({
          color:'danger',
          title:'에러',
          text:'과목명을 설정해 주세요'
        })
        this.activePrompt3 = true
      }
      var start = this.timeList.findIndex(val => {return val == this.oldData.start_data})
      var end = this.timeList.findIndex(val => {return val == this.oldData.end_data})
      for(start; start < end; start++){
        this.timeTableVal[start][this.oldData.week] = 0
      }
      this.$store.dispatch("timeTable/updateTimeTable", this.newData).then(()=>{
        this.setScheduleVector()
      })
    },
    acceptAddSchedule(){
      if(this.newData.start_data == '' || this.newData.end_data == '' ){
        this.$vs.notify({
          color:'danger',
          title:'에러',
          text:'시작 시간과 종료 시간을 설정해주세요'
        })
        this.activePrompt = true
      }
      if(this.newData.class_name == ''){
        this.$vs.notify({
          color:'danger',
          title:'에러',
          text:'과목명을 설정해 주세요'
        })
        this.activePrompt = true
      }
      this.$store.dispatch("timeTable/createTimeTable", this.newData).then(()=>{
        this.setScheduleVector()
      })
    },
    editSchedule(val, week, num){
      this.clearFields()
      Object.assign(this.oldData, this.schedules[val])
      Object.assign(this.newData, this.schedules[val])
      this.startTimeSelected = this.newData.start_data
      this.activePrompt3 = true
      this.editTimeList = []
      this.startTimeList = []
      var index = 0
      for (index = num-1; index >= 0; index--){
        if(this.timeTableVal[index][this.newData.week] == 0 || this.timeTableVal[index][this.newData.week] == val+1){
          this.editTimeList.push(this.timeList[index])
          this.startTimeList.push(this.timeList[index])
        }
      }
      for(index = num; index < this.timeList.length; index++){
        if(this.timeTableVal[index][this.newData.week] == 0 || this.timeTableVal[index][this.newData.week] == val+1){
            this.editTimeList.push(this.timeList[index])
            this.startTimeList.push(this.timeList[index])
        }else {
          this.editTimeList.push(this.timeList[index])
          this.startTimeList.push(this.timeList[index])
          break
        }
      }
      this.editTimeList.sort()
      this.startTimeList.sort()
      this.startTimeList.splice(this.startTimeList.length-1,1)
      this.resetEndTimeList()
      //this.setStartEndTimeList()
    },
    addSchedule(week, num){
      this.clearFields()
      this.newData.week = week
      this.selectStartIndex = num-1
      this.newData.start_data = this.timeList[num-1]
      this.activePrompt = true
      this.selectEventFlag = !this.selectEventFlag
    },
    clearFields() {
      this.newData = {
        table_id:this.timeTableInfo.id,
        color:'#ffffff',
        room:'',
        class_name:'',
        professor:'',
        start_data:'',
        end_data:'',
        week:0,
        workspace_id:0
      }
    },
    setTimeTable(){
      if(this.timeTableInfo.minutes == '30'){
        this.timeList = []
        var size = ((this.$moment(this.timeTableInfo.end_data, 'HH:mm').get('hours') - this.$moment(this.timeTableInfo.start_data,'HH:mm').get('hours')) * 2)
        this.timeList.push(this.$moment(this.timeTableInfo.start_data, 'HH:mm').format("HH:mm"))
        for (var i = 1; i < size+1; i++){
          var item = this.$moment(this.timeTableInfo.start_data, 'HH:mm').add(30*i, 'm').format("HH:mm")
           this.timeList.push(item)
        }
        if (this.$moment(this.timeList[this.timeList.length-1])._i < this.$moment(this.timeTableInfo.end_data,'HH:mm')._i){
          size = size + 1
          this.timeList.push(this.$moment(this.timeTableInfo.end_data,'HH:mm')._i)
        }
        this.timeListSize =  this.timeList.length
      }else{
        this.timeList = []
        var size2 = this.$moment(this.timeTableInfo.end_data, 'HH:mm').get('hours') - this.$moment(this.timeTableInfo.start_data,'HH:mm').get('hours')
        this.timeList.push(this.$moment(this.timeTableInfo.start_data, 'HH:mm').format("HH:mm"))
        for (var j = 1; j < size2+1; j++){
          var item2 = this.$moment(this.timeTableInfo.start_data, 'HH:mm').add(60*j, 'm').format("HH:mm")
           this.timeList.push(item2)
        }
        if (this.$moment(this.timeList[this.timeList.length-1])._i < this.$moment(this.timeTableInfo.end_data,'HH:mm')._i){
          size2 = size2 + 1
          this.timeList.push(this.$moment(this.timeTableInfo.end_data,'HH:mm')._i)
        }
        this.timeListSize =  this.timeList.length
      }
      this.timeTableVal = []
      for(var k = 0; k < this.timeListSize; k++){
        this.timeTableVal.push([0,0,0,0,0])
      }
    },
    acceptAlert(){
     if((this.timeTableInfo.start_data == null || this.timeTableInfo.end_data == null) || this.$moment(this.timeTableInfo.start_data,'HH:mm').get('hours') > this.$moment(this.timeTableInfo.end_data, 'HH:mm').get('hours')){
       this.$vs.notify({
         color:'danger',
         title:'에러',
         text:'시작 시간과 종료 시간을 설정해주세요'
       })
     }
     else {
       this.$store.dispatch("timeTable/editTimeTableSetting", this.timeTableInfo).then(()=>{
        this.setTimeTable()
        this.$vs.notify({
         color:'success',
         title:'설정 완료',
        })
      })
     }
    },
  },
  components: {
    swiper,
    swiperSlide,
    flatPickr,
    moduleTimeTable,
    'v-select': vSelect,
  }
}
</script>

<style>
  button:focus {border-color: black;}
</style>
